import type { ProductType as CommonProductType } from '@labrav/common'

import { CloudTypeEnum as CommonCloudTypeEnum } from '@labrav/common'

export * from './flyout'

export enum CloudType {
  AWS = CommonCloudTypeEnum.AWS,
  AZURE = CommonCloudTypeEnum.AZURE,
  GCP = CommonCloudTypeEnum.GCP,
  REDHAT = CommonCloudTypeEnum.REDHAT,
}
export const cloudTypeToApiValue = (cloudType: CloudType) =>
  cloudType.toLowerCase()

export type ContractType = 'PUBLIC' | 'PRIVATE'

export interface links {
  self: string
  nextPage?: string
  previousPage?: string
}

export type CloudMarketplace = 'AWS' | 'GCP' | 'AZURE' | 'REDHAT'

export enum CloudProvider {
  AWS = 'aws',
  GCP = 'gcp',
  AZ = 'azure',
  REDHAT = 'redhat',
}

export enum FlyoutOnboardingPartnershipType {
  ISV = 'ISV',
  CP = 'CP',
  ISV_AND_CP = 'ISV_AND_CP',
}

export type AWSPartnerTier = 'registered' | 'select' | 'advanced' | 'premier'

export type {
  ResaleAuthorizationsResellerAgreements,
  ResellerInfo,
} from './resaleAuthorization'
export type { MarketplaceTemplateDataResponse } from './mappingManager'

export type AccountType = string

export interface TemplateRows {
  [key: string]: unknown
}

export type Account = {
  id: string
  cloudType: CloudType
  organizationId: string
  status: string
  accountDetails: {
    id: string
    externalAccountId: string
    name: string
    type: AccountType
    cloudAccountId: string
    roles: { rows: TemplateRows[] }
  }
}

export type ProductType = CommonProductType

export type UpdateResellerDataToBeSent = {
  status: string
  awsAgreementId: string
}

export interface FreeTrials {
  productId: string
  freeTrial: Record<string, unknown>
  eulaType?: string
  eulaFile?: string[]
  selectedEulaFiles?: File[]
  productDimensions: Record<string, unknown>[]
  onReview?: boolean
}

export type PartnerSubscriptionsListParams = {
  partnerId: string
  productId?: string
  pageSize?: number
  pageNumber?: number
  status?: string
  expiringDays?: string
  crmOpportunityId?: string
  privateOfferId?: string
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  companyName?: string
  awsAccountId?: string
  awsOfferId?: string
  awsAgreementId?: string
  contractStatusUpdate?: boolean
}

export type GetRevenueInsightsReport = {
  partnerId: string
  reportType: string
  cloudMarketplace: string
  finalStartDate: string
  finalEndDate: string
  downloadReport: boolean
  pageSize: number
  pageNumber: number
  productId?: string
  sortBy?: string
  sortOrder?: string
}

export type GetRevenueInsightsReportV2 = {
  partnerId: string
  finalStartDate: string
  finalEndDate: string
  downloadReport?: boolean
  pageSize: number
  pageNumber?: number
  productId?: string
  dateRangeType?: string
  paymentStatus?: string
  offerType?: string
  disbursementDate?: string | number
  paymentDueDate?: string | number
  paymentDelayedSince?: string | number
  lastEvaluatedKeys?: string
  lastEvaluatedValues?: string
  sortBy?: string
  sortOrder?: string
  shouldSendGetDateParam?: boolean
  input?: string
  selectedInput?: string
  sectionName?: string
  companyName?: string
  offerId?: string
  accountId?: string
}
